import { gridSizeMdLg6 } from "@/shared"
import { CustomTextField, CustomTextFieldNoForm, TabTextLabel } from "@/shared/components/ui"

export type OTDetalleVisitaFormTab = {
    form: any
    errors: any
    shrink: boolean

}
export default function OTDetalleClientVisitaTecnicoFormTab({ form, errors, shrink }: OTDetalleVisitaFormTab) {
    console.log("form**", form)
    return <>
        <TabTextLabel
            text="Cliente"
            pb={2}
            pt={2}
        />
        <CustomTextField
            name="tipo_identificacion"
            label="Tipo de Indentificación"
            control={form.control}
            defaultValue={form.control}
            error={errors.tipo_identificacion}
            helperText={errors.tipo_identificacion?.message?.toString() ?? ""}
            shrink={shrink}
            size={gridSizeMdLg6}
            disabled
        />
        <CustomTextField
            name="identificacion"
            label="No. Identificación"
            control={form.control}
            defaultValue={form.getValues().identificacion || ""}
            error={errors.identificacion}
            helperText={errors.identificacion?.message?.toString() ?? ""}
            shrink={shrink}
            size={gridSizeMdLg6}
            disabled
        />
        <CustomTextField
            name="razon_social"
            label="Nombre"
            control={form.control}
            defaultValue={form.getValues().razon_social || ""}
            error={errors.razon_social}
            helperText={errors.razon_social?.message?.toString() ?? ""}
            shrink={shrink}
            size={gridSizeMdLg6}
            disabled
        />
        <CustomTextFieldNoForm
            label="Ciudad"
            value={form?.getValues()?.ciudad_data?.nombre || "N/A"}
            disabled
            size={gridSizeMdLg6}
        />
        <CustomTextField
            name="direccion"
            label="Dirección"
            control={form.control}
            defaultValue={form.getValues().direccion}
            error={errors.direccion}
            helperText={errors.direccion?.message?.toString() ?? ""}
            shrink={shrink}
            disabled
        />
    </>
}